export default "__VITE_ASSET___app/immutable/assets/default-avatar-4.x6cItHr7.svg__"